import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useNotification } from 'config/Notification';

import {
  Button,
  InputAdornment,
  CardHeader,
  CircularProgress,
  Divider,
  // Dialog,
  // DialogTitle,
  // DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Paper,
  TablePagination,
  TextField,
  Select,
  MenuItem
} from '@mui/material';

// import { styled } from '@mui/material/styles';
// import IconButton from '@mui/material/IconButton';
// import CloseIcon from '@mui/icons-material/Close';
// import Typography from '@mui/material/Typography';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

import { getAllCAPUsersService, userActivateService, userDeactivateService } from 'services/modules/idp/user';

const UsersListCAP = () => {
  // State variables
  const [userData, setUserData] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  // const [open, setOpen] = useState(false);

  // Redux selectors
  const companyDataContainer = useSelector(state => state.auth.companyData);
  const loginIdContainer = useSelector((state) => state.auth.user.id);

  // React router
  const navigate = useNavigate();

  // Notification
  const { openNotification } = useNotification();

  useEffect(() => {
    if (companyDataContainer?.companyid !== null)
      fetchUsersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyDataContainer, rowsPerPage]);

  // Method to fetch the users data based on the company id
  const fetchUsersData = async () => {
    try {
      const params = {
        company: companyDataContainer?.companyid,
        sortBy: '-createdAt',
        limit: rowsPerPage
      };
      const response = await getAllCAPUsersService(params);
      setUserData(response);
    } catch (error) {
      openNotification('Server error', error);
    }
  };

  // Handles page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handles change in rows per page
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Handles change in search query like username,email and createdAt date
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  // Handles navigation to profile component
  const handleViewProfile = (userId) => {
    navigate(`/profile/${userId}`)
  };

  // Handles navigation to add user component
  const handleAdduser = () => {
    navigate(`/add-user/${companyDataContainer?.companyid}`)
  };

  // Handles navigation to update profile component
  const handeUpdateProfile = (userId) => {
    navigate(`/update-profile/${userId}`)
  };

  // filtering user data based on username,email and createdAt date
  const filteredUserData = userData ? userData.filter((user) =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase()) || user.createdAt.toLowerCase().includes(searchQuery.toLowerCase())
  )
    : [];

  // const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  //   '& .MuiDialogContent-root': {
  //     padding: theme.spacing(2),
  //   },
  //   '& .MuiDialogActions-root': {
  //     padding: theme.spacing(1),
  //   },
  // }));

  // Handles dropdown change for activating or deactivating user
  const handleDropdownChange = async (e, userId) => {
    try {
      if (!e || !e.target) {
        return;
      }
      if (e.target.value === "INACTIVE") {
        let response = await userDeactivateService({ userId });
        if (response !== 200) {
          openNotification('Deactivated failed')
        }
        else {
          fetchUsersData();
          openNotification('Deactivated successfully')
        }
      }
      else {
        let response = await userActivateService({ userId });
        if (response !== 200) {
          openNotification('Activated failed')
        }
        else {
          fetchUsersData();
          openNotification('Activated successfully')
        }
      }
    }
    catch (error) {
      console.error('Error handling dropdown change:', error);
    }
  };

  return (
    <div className='card-container'>
      <div className='users-card p-2 full-width-field'>
        <CardHeader
          title={
            <React.Fragment>
              <div className='card-head'>
                <div className="flex-head">
                  <img src="/assets/groupsvc.5fc77efe.jpg" alt="icon" className="card-icon" />
                  <label className='label'> Users</label>
                </div>

                <div><Button variant="contained" onClick={() => handleAdduser()}>+ Add new user</Button></div>

              </div>
            </React.Fragment>

          } />
        <Divider className='divider' />
        <div className="card-bottom-container">
          <div className="input-card">
            <div>
              <div className="search">
                <TextField
                  variant="outlined"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>

            <div>
              <span>
                <Button
                  variant="contained"
                  className="back font mt-3"
                  // onClick={() => window.history.back()}
                  onClick={() => navigate('/companies')}
                >
                  Back
                </Button>
              </span>
              {/* <React.Fragment>
                <Button className='card-button' onClick={() => setOpen(!open)} variant="contained" >
                  What is role
                </Button>
                <BootstrapDialog
                  open={open}
                >
                  <DialogTitle sx={{ m: 0, p: 2 }} >
                    How role works
                  </DialogTitle>
                  <IconButton
                    onClick={() => setOpen(!open)}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <DialogContent dividers>
                    <Typography gutterBottom>
                      <ol>
                        <li>
                          <p className='card-subtext'>Admin</p>
                          <ul className='card-text'>
                            <li>Can create, manage users</li>
                            <li>Can assign roles (superuser, user) to users</li>
                            <li>Can create, edit, delete child company</li>
                            <li>Can add, edit users for child company</li>
                            <li>Can view assessments, dashboard</li>
                          </ul>
                        </li>
                        <li>
                          <p className='card-subtext'>Superuser</p>
                          <ul className='card-text'>
                            <li>Can assign, cancel assessments to users</li>
                            <li>Can review, approve, reject assessments</li>
                            <li>Can assign, review, reject mitigation plan for assessments</li>
                            <li>Can view assessments, dashboard</li>
                          </ul>
                        </li>
                        <li>
                          <p className='card-subtext'>User</p>
                          <ul className='card-text'>
                            <li>Can submit assessments</li>
                            <li>Can upload evidence, remarks for mitigation plans</li>
                            <li>Can view assessments, dashboard</li>
                          </ul>
                        </li>
                      </ol>
                    </Typography>
                  </DialogContent>
                </BootstrapDialog>
              </React.Fragment> */}
            </div>
          </div>
          <div>
            <TableContainer component={Paper}>
              <Table>
                <TableHead className="table-head">
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Assessments</TableCell>
                    <TableCell>Created on</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userData === null ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : filteredUserData?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center"><ReportProblemIcon /> No user data available</TableCell>
                    </TableRow>
                  ) : (
                    (
                      filteredUserData?.map((user) => (
                        <TableRow className="table-row" key={user.id}>
                          <TableCell className="name-table">{user.name}
                            <Tooltip title="Admin">
                              {user.role === "Admin" && (
                                <VerifiedUserRoundedIcon className="admin-icon-table" />
                              )}
                            </Tooltip>
                            <Tooltip title="Super admin">
                              {user.role === "Super Admin" && (
                                <AdminPanelSettingsIcon className="admin-icon-table" />
                              )}
                            </Tooltip>
                            <Tooltip title="Analyst">
                              {user.role === "Analyst" && (
                                <PersonSearchIcon className='analyst-icon-table' />
                              )}
                            </Tooltip>
                          </TableCell>
                          <TableCell className="role-table">{user.role}</TableCell>
                          <TableCell className="table-email">{user.email}</TableCell>
                          <TableCell className="table-text">{user.assessments || '0'}</TableCell>
                          <TableCell className="table-text">{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                          <TableCell>
                            <Select variant="standard" className={`status-dropdown ${user.status === 'ACTIVE' ? 'active-status' : 'inactive-status'}`} defaultValue={user.status} disabled={loginIdContainer === user.id ? true : false} onChange={(e) => handleDropdownChange(e, user.id)}>
                              <MenuItem value="ACTIVE" className={user.status === 'ACTIVE' ? 'active-item' : 'not-active-item'}>Active</MenuItem>
                              <MenuItem value="INACTIVE" className={user.status === 'INACTIVE' ? 'active-item' : 'inactive-item'} >InActive</MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell>
                            <Tooltip title="View User" placement="top">
                              <img src="/assets/viewicon.svg" alt="View" className='icons-style' onClick={() => handleViewProfile(user.id)} />
                            </Tooltip>
                            <Tooltip title="Edit User" placement="top">
                              <div className="edit-container" onClick={() => handeUpdateProfile(user.id)}>
                                <EditIcon className='usersandediticon' />
                              </div>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))
                    )
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 7, 10, 15, 20, 25, 50]}
                component="div"
                count={userData?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersListCAP;
